import { useContext, useSyncExternalStore } from 'react';
import { TableContext } from './useTableContext';
import {
  getActiveFullscreenTable,
  subscribeToFullscreenTable,
} from '../fullscreen';

/**
 * The fullscreen table's root node, or `undefined` when no table is fullscreen.
 *
 * That node is a fixed, z-10000 stacking context, so anything layered over the
 * page — a dialog, a popup — has to render inside it to stay visible. Uses the
 * surrounding table when it is fullscreen, and otherwise whichever table is,
 * which covers surfaces rendered outside any table.
 */
export function useFullscreenTableContainer() {
  const tableContext = useContext(TableContext);
  const activeFullscreenTable = useSyncExternalStore(
    subscribeToFullscreenTable,
    getActiveFullscreenTable,
    () => null,
  );

  return tableContext?.isFullscreen
    ? (tableContext.fullscreenContainer ?? undefined)
    : (activeFullscreenTable ?? undefined);
}
